<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>bug_report</md-icon>
          </div>
          <h4 class="title">Application Over Usages Alerts</h4>
        </md-card-header>
        <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-size-50">
                <md-field>
                  <md-datepicker v-model="fromDate" md-immediately>
                    <label>From Date</label>
                  </md-datepicker>
                </md-field>
              </div>
              <div class="md-layout-item md-size-50">
                <md-field>
                  <md-datepicker v-model="toDate" md-immediately>
                    <label>To Date</label>
                  </md-datepicker>
                </md-field>
              </div>
              <div class="md-layout-item md-size-50">
                <md-field>
                  <md-input type="text" class="box-textbox" placeholder="Serial Number" v-model="serialNumber"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-25">
                  <md-button class="md-primary" :disabled="isDisabled" @click="applicationOveruseAlertList()">Search</md-button> 
              </div>
          </div>
          <hr>
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Per page</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Serial Number" md-sort-by="serialNumber">
                    {{ item.serialNumber }} <br>
                    <span><b>App Version:</b> {{ item.appVersion }}</span>
                </md-table-cell>
                <md-table-cell md-label="Package Name" md-sort-by="appTitle">
                    <span><b>Title:</b> {{ item.appTitle }}</span><br>
                    <span><b>Category:</b> {{ item.playStoreCategory }}</span>
                </md-table-cell>
                <md-table-cell md-label="Value">
                    <span><b>Configure Limit:</b> {{ item.dailyLimit }}</span><br>
                    <span><b>Used Limit:</b> {{ item.timeInMinute }}</span>
                </md-table-cell>
                <md-table-cell md-label="Type" md-sort-by="appDisableType">
                    <span :class="statusClass(item.appDisableType)">
                        {{ item.appDisableType }}
                    </span>
                </md-table-cell>
                <md-table-cell md-label="Date" md-sort-by="date">{{ item.date }}</md-table-cell>
                <md-table-cell md-label="Created" md-sort-by="created_at">{{ HumanReadableDateFormat(item.created_at, true) }}</md-table-cell>                
            </md-table-row>

          </md-table>
          
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class="">
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import Swal from "sweetalert2";
import DeviceDataService from "../../services/SuperAdmin/DeviceDataService";

export default {
  components: {
    Pagination,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      currentSort: "orderId",
      currentSortOrder: "asc",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      tableData: [],
      searchedData: [],
      serialNumber:"",
      fromDate:new Date().toISOString().split('T')[0],
      toDate:new Date().toISOString().split('T')[0]
    };
  },
  methods: {
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    statusClass(status) {
        switch (status) {
            case "Application Daily Limit":
                return "badge badge-success";
            case "Global Daily Limit":
                return "badge badge-primary";
            case "Category Daily Limit":
                return "badge badge-warning";
            case "Delivered":
                return "badge badge-info";
            default:
                return "";
        }
    },
    applicationOveruseAlertList() {
        let data = { fromDate: this.fromDate, toDate: this.toDate, serialNumber: this.serialNumber };
        DeviceDataService.applicationOveruseAlertList(data)
          .then((response) => {
            this.tableData = response.data.data;
          })
          .catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
          });
    },
  },
  beforeMount() {
    this.applicationOveruseAlertList();
  },
  mounted() {
  },
  watch: {
  },
};
</script>

<style scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
::v-deep .md-table-cell {
  word-wrap: break-word;
  white-space: normal;
  vertical-align: top;
}

::v-deep .md-table-cell[md-label="Email"],
::v-deep .md-table-cell[md-label="Order Status"] {
  min-width: 160px;
}
</style>
